import React from 'react';
import Header from './Header';
import { Helmet } from 'react-helmet-async';

function Layout({ children, title }) {
    return (
    <>
      <Helmet>
        <link rel="stylesheet" href="/css/common.css" />
        <link rel="stylesheet" href="/css/sub.css" />
        <link rel="stylesheet" href="/css/custom.css" />
      </Helmet>
      
       <div id="wrap" >
        <Header title={title} />
            {children}
      </div>
    </>
    );
}

export default Layout;
